import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import LevelList from './editTiers/levelList.js';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from 'react-helmet';
import { validateTokenAndResetPassword } from '../../actions/user.js';

class PasswordReset extends Component{

    constructor(props) {
        super(props);
        console.log('constructed with props');
        console.log(props);
        this.state = {
            beforeReset: true,
            passwordSent: false
        };
    }
    componentDidMount(props) {
        console.log("did mount with props");
        console.log(this.props.match.params.token);
        if(this.props.match.params.token && this.state.beforeReset) {
            validateTokenAndResetPassword(this.props.match.params.token, function(ret){
                var newState = {beforeReset: false};
                newState.passwordSent = ret;
                this.setState(newState);
            }.bind(this));
        }
    }
    render() {
        return (
            <div>
                <Helmet>
                    <title>Password Reset | Edit My Paper</title>
                    <meta name="description" content="It is essential that you Accept or Reject all of your editor's changes and remove his/her comments prior to submitting your document."></meta>
                    <meta name="keywords" content="Edit,My,Paper,Editing,Examples,University,College,Students"></meta>
                </Helmet>
                <TopNav  mobileSupported={true}/>
                <section className="steps top_section">
                    <div id="login-wrapper">
                        <div id="login-form" className="col-md-offset-3 col-md-6">
                            {(this.state.beforeReset)? 
                                <div>
                                    Validating Token
                                </div>
                                :
                                <div>
                                    {(this.state.passwordSent)?
                                        <div>We have sent you a new password. Check your inbox, and click <a href="/login">here to login</a></div>
                                        :
                                        <div>
                                            Something went wrong. You can try to <a href="/forgot">reset password again</a>.<br/>
                                            If the issue persists, please contact us at info@editmypaper.ca.
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </section>
                <Footer></Footer>
            </div>
        )
    }
}
export default connect(
  )(PasswordReset);
  


// WEBPACK FOOTER //
// ./src/components/pages/PasswordReset.js